import React from "react";

export default function SimCardRechargeStyle() {

    return (
        <style type="text/css">
            {`
            .rounded-custom {
              border-radius: 10px;
            }
            .operator {
              cursor: pointer;
            }
            .mtn-bg-color {
              background-color: #f7c505;
            }
            .mtn:hover {
              background-color: #f7c505;
            }
            .mci-bg-color {
              background-color: #54c5d0;
            }
            .mci:hover {
              background-color: #54c5d0;
            }
            .rightel-bg-color {
              background-color: #942a68;
            }
            .rightel:hover {
              background-color: #942a68;
            }
            .price-box {
              background-color: #ffffff;
              box-shadow: 0 0 0 1px #ebedef;
            }
            .box-shadow {
              box-shadow: 0 0 0 1px #ebedef;
            }
            .card-box {
              cursor: pointer;
            }
            .price-box:hover {
              background: #67C9F3;
              color: #ffffff;
            }
            .price-box-selected {
              background: #03a9f4;
              color: #ffffff;
            }
            .buy-btn {
              background-color: #06C46C;
              font-size: 1.125rem;
            }
            .buy-btn:hover {
                background-color: #007D44;
            }
            .modal-header {
                border-bottom: none;
            }
            .modal-footer {
                border-top: none
            }
            .table td {
                padding: 2px 0;
            }
            .btn-disabled {
                background-color: #eee !important;
                cursor: none;
            }
            .modal-content {
                background: rgba( 255, 255, 255, 0.95 );
                box-shadow: 0 8px 32px 0 rgba( 31, 38, 135, 0.37 );
                backdrop-filter: blur( 4px );
                -webkit-backdrop-filter: blur( 4px );
                border-radius: 10px;
                border: 1px solid rgba( 255, 255, 255, 0.18 );
            }
        `}
        </style>
    );
}
